import {
	makeStyles,
	Tab,
	Tabs,
	TextField,
	withStyles,
	Select,
	MenuItem,
	InputLabel,
	FormControl,
} from '@material-ui/core';
import React, { useState } from 'react';
import './Client.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { TextFields } from '@material-ui/icons';
import Calendar from 'react-calendar';
import clsx from 'clsx';
import PlacesAutocomplete, {
	geocodeByAddress,
	getLatLng,
} from 'react-places-autocomplete';
import { range } from 'lodash';
import dayjs from 'dayjs';
import { useEffect } from 'react';

function Client({
	individualDetails,
	individualSecondPurchaserDetails,
	setIndividualDetails,
	setIndividualSecondPurchaserDetails,
	setCorporationDetails,
	setDisable,
	disable,
	setIsCompleted,
	isCompleted,
	setClientZipCode,
}) {
	const [value, setValue] = useState(0);
	const [individualDob, setIndividualDob] = useState(
		new Date(new Date().setFullYear(new Date().getFullYear() - 18))
	);
	const [individualSecondPurchaserDob, setIndividualSecondPurchaserDob] =
		useState(
			new Date(new Date().setFullYear(new Date().getFullYear() - 18))
		);
	const [businessDob, setBusinessDob] = useState(new Date());
	const [showCalendar, setShowCalendar] = useState(false);
	const [showSecondCalendar, setShowSecondCalendar] = useState(false);
	const [address, setAddress] = useState(
		individualDetails?.address ? individualDetails?.address : ''
	);
	const [addressSecondPurchaser, setAddressSecondPurchaser] = useState(
		individualSecondPurchaserDetails?.address
			? individualSecondPurchaserDetails?.address
			: ''
	);
	const [businessAddress, setBusinessAddress] = useState('');
	const [showSecondPurchaser, setShowSecondPurchaser] = useState(false);
	const [secondPurchaserFormData, setSecondPurchaserFormData] = useState({
		secondFirstName:
			individualSecondPurchaserDetails?.firstName !== undefined
				? individualSecondPurchaserDetails?.firstName
				: '',
		secondLastName:
			individualSecondPurchaserDetails?.lastName !== undefined
				? individualSecondPurchaserDetails?.lastName
				: '',
		secondEmail:
			individualSecondPurchaserDetails?.email !== undefined
				? individualSecondPurchaserDetails?.email
				: '',
		secondPhoneNumber:
			individualSecondPurchaserDetails?.phoneNumber !== undefined
				? individualSecondPurchaserDetails?.phoneNumber
				: '',
		secondOccupation:
			individualSecondPurchaserDetails?.occupation !== undefined
				? individualSecondPurchaserDetails?.occupation
				: '',
		secondDlNumber:
			individualSecondPurchaserDetails?.dlNumber !== undefined
				? individualSecondPurchaserDetails?.dlNumber
				: '',
		secondIdType: 'Driver License',
	});
	const [formData, setFormData] = useState({
		firstName:
			individualDetails?.firstName !== undefined
				? individualDetails?.firstName
				: '',
		lastName:
			individualDetails?.lastName !== undefined
				? individualDetails?.lastName
				: '',
		phoneNumber:
			individualDetails?.phoneNumber !== undefined
				? individualDetails?.phoneNumber
				: '',
		occupation:
			individualDetails?.occupation !== undefined
				? individualDetails?.occupation
				: '',
		dlNumber:
			individualDetails?.dlNumber !== undefined
				? individualDetails?.dlNumber
				: '',
		idType: 'Driver License',
	});

	const [formDataBusiness, setFormDataBusiness] = useState({
		corporationName: '',
		businessType: '',
		registrationNumber: '',
		directorFName: '',
		directorLName: '',
		businessPhone: '',
	});

	const { firstName, lastName, phoneNumber, occupation, dlNumber, idType } =
		formData;
	const {
		secondFirstName,
		secondLastName,
		secondEmail,
		secondPhoneNumber,
		secondOccupation,
		secondDlNumber,
		secondIdType,
	} = secondPurchaserFormData;
	const {
		corporationName,
		businessType,
		registrationNumber,
		directorFName,
		directorLName,
		businessPhone,
	} = formDataBusiness;

	const onChange = (e) =>
		setFormData({ ...formData, [e.target.name]: e.target.value });

	const onChangeSecondPurchaser = (e) => {
		console.log(
			'secondPurchaserFormData: ' +
				JSON.stringify(secondPurchaserFormData)
		);
		setSecondPurchaserFormData({
			...secondPurchaserFormData,
			[e.target.name]: e.target.value,
		});
	};

	const onChangeBusiness = (e) =>
		setFormDataBusiness({
			...formDataBusiness,
			[e.target.name]: e.target.value,
		});

	const handleChange = (event, newValue) => {
		setValue(newValue);

		if (newValue === 0) {
			setCorporationDetails();
			setFormDataBusiness({
				corporationName: '',
				businessType: '',
				businessAddress: '',
				registrationNumber: '',
				directorFName: '',
				directorLName: '',
			});
			setBusinessAddress('');
		} else if (newValue === 1) {
			setIndividualDetails();
			setFormData({
				firstName: '',
				lastName: '',
				dob: '',
				phoneNumber: '',
				occupation: '',
				dlNumber: '',
				idType: 'Driver License',
			});
			setAddress('');
		}
	};

	const handleRemoveSecondPurchaser = () => {
		setShowSecondPurchaser(false);
		setSecondPurchaserFormData({
			secondFirstName: '',
			secondLastName: '',
			dob: '',
			secondEmail: '',
			secondPhoneNumber: '',
			secondOccupation: '',
			secondDlNumber: '',
			secondIdType: 'Driver License',
		});
		setIndividualSecondPurchaserDetails();
	};

	const useStyles = makeStyles((theme) => ({
		root: {
			flexGrow: 1,
			borderRadius: 8,
		},
		clientTab: {
			backgroundColor: '#F1F5F8',
			marginBottom: '1em',
			boxShadow: '0px 1px 8px rgba(20, 46, 110, 0.1)',
			width: '22em',
		},
		form: {
			display: 'flex',
			flexDirection: 'column',
		},
		field: {
			marginBottom: '20px',
			width: '41em',
			margin: '20px',
			'& .MuiInput-underline:after': {
				borderBottomColor: 'blue',
				borderBottom: '2px solid',
			},
		},
		datePicker: {
			height: '36px',
			borderTop: 'none',
			borderLeft: 'none',
			borderRight: 'none',
			outline: 'none',
			borderBottom: '1px solid #949494',
			borderRadius: '0',
		},
		label: {
			marginBottom: '-2.3em',
			fontSize: '10px',
			color: 'grey',
		},
	}));

	const StyledTabs = withStyles({
		indicator: {
			display: 'flex',
			justifyContent: 'center',
			backgroundColor: 'transparent',
		},
	})((props) => (
		<Tabs {...props} TabIndicatorProps={{ children: <span /> }} />
	));

	const StyledTab = withStyles((theme) => ({
		root: {
			textTransform: 'none',
			color: '#636D73',

			'&.Mui-selected': {
				backgroundColor: '#FFFFFF',
				boxShadow: '0px 1px 8px rgba(20, 46, 110, 0.1)',
				borderRadius: '8px',
				color: '#2662F0',
			},
		},
	}))((props) => <Tab {...props} />);

	const styles = useStyles();

	useEffect(() => {
		console.log('individualDob ', individualDob);
	}, [individualDob]);

	const handleSave = () => {
		setDisable({ ...disable, client: false });
		if (value === 0) {
			console.log('Sending Individual details');
			setIndividualDetails({
				firstName: firstName,
				lastName: lastName,
				phoneNumber: phoneNumber,
				dob: individualDob,
				occupation: occupation,
				dlNumber: dlNumber,
				address: address,
				idType: idType,
			});

			console.log(
				' Second purchaser details: ' +
					secondFirstName +
					secondLastName +
					secondPhoneNumber +
					individualSecondPurchaserDob +
					secondDlNumber +
					addressSecondPurchaser
			);

			setIndividualSecondPurchaserDetails({
				firstName: secondFirstName,
				lastName: secondLastName,
				email: secondEmail,
				phoneNumber: secondPhoneNumber,
				dob: individualSecondPurchaserDob,
				dlNumber: secondDlNumber,
				occupation: secondOccupation,
				address: addressSecondPurchaser,
				idType: secondIdType,
			});
		} else if (value === 1) {
			console.log('Sending corporation details');

			setCorporationDetails({
				corporationName: corporationName,
				businessType: businessType,
				registrationNumber: registrationNumber,
				directorFName: directorFName,
				directorLName: directorLName,
				businessPhone: businessPhone,
				dob: businessDob,
				businessAddress: businessAddress,
			});
		}
	};

	const handleSelect = async (value) => {
		const results = await geocodeByAddress(value);

		console.log('handleSelect value');

		var zipCode = results[0]?.address_components[7]?.long_name;

		setClientZipCode(zipCode);
		setAddress(value);
	};

	const handleSelectSecondPurchaser = async (value) => {
		const results = await geocodeByAddress(value);

		var zipCode = results[0]?.address_components[7]?.long_name;

		setClientZipCode(zipCode);
		setAddressSecondPurchaser(value);
	};

	const handleSelectBusiness = async (value) => {
		const results = await geocodeByAddress(value);
		setBusinessAddress(value);
	};

	const inputProps = (getInputProps) =>
		getInputProps({
			placeholder: 'Address',
		});

	return (
		<div className='doc_card client_wrapper'>
			<div className='card_title'>Who is this agreement for?</div>
			<div className={styles.root}>
				<div className={styles.clientTab}>
					<StyledTabs value={value} onChange={handleChange} centered>
						<StyledTab label={'Invidividual'} />
						<StyledTab label={'Corporation'} />
					</StyledTabs>
				</div>
				{value === 0 ? (
					<div className='client_form'>
						<div className={styles.form}>
							<TextField
								type='text'
								label='First Name'
								name='firstName'
								value={firstName}
								className={styles.field}
								onChange={(e) => onChange(e)}
							/>
							<TextField
								type='text'
								label='Last Name'
								name='lastName'
								value={lastName}
								onChange={(e) => onChange(e)}
								className={styles.field}
							/>

							<TextField
								type='tel'
								label='Phone Number'
								className={styles.field}
								pattern='[0-9]{3}[0-9]{3}[0-9]{4}'
								name='phoneNumber'
								value={phoneNumber}
								onChange={(e) => onChange(e)}
							/>

							{/* <DatePicker
								selected={individualDob}
								id='date'
								placeholderText='Date of Birth'
								maxDate={Date.now()}
								onChange={(date) => setIndividualDob(date)}
								className={clsx(styles.field, styles.datePicker)}
								showTimeSelect={false}
							/> */}

							<TextField
								type='text'
								label='Date of Birth'
								name='individualDob'
								value={dayjs(new Date(individualDob)).format(
									'DD MMM YYYY'
								)}
								className={styles.field}
								onChange={(e) => onChange(e)}
								onClick={() => setShowCalendar(true)}
							/>

							{showCalendar === true && (
								<div className='dates_wrapper'>
									<Calendar
										onChange={(e) => {
											setIndividualDob(
												new Date(e).getTime()
											);
											setShowCalendar(false);
										}}
										value={new Date(individualDob)}
										className='new-react-calendar'
										maxDate={
											new Date(
												new Date().setFullYear(
													new Date().getFullYear() -
														18
												)
											)
										}
										showFixedNumberOfWeeks={true}
									/>
								</div>
							)}

							<TextField
								type='text'
								label='Occupation'
								name='occupation'
								value={occupation}
								className={styles.field}
								onChange={(e) => onChange(e)}
							/>

							<FormControl className={styles.field}>
								<InputLabel id='id-type-select-label'>
									ID Type
								</InputLabel>
								<Select
									labelId='id-type-select-label'
									id='id-type-select'
									value={idType}
									name='idType'
									onChange={(e) => onChange(e)}
								>
									<MenuItem value='Driver License'>
										Driver License
									</MenuItem>
									<MenuItem value='Passport'>
										Passport
									</MenuItem>
									<MenuItem value='Permanent Residence Card'>
										Permanent Residence Card
									</MenuItem>
									<MenuItem value='other'>other</MenuItem>
								</Select>
							</FormControl>

							<TextField
								type='text'
								label='ID Number'
								name='dlNumber'
								value={dlNumber}
								className={styles.field}
								onChange={(e) => onChange(e)}
							/>

							<PlacesAutocomplete
								value={address}
								onChange={setAddress}
								onSelect={handleSelect}
								className={styles.field}
							>
								{({
									getInputProps,
									suggestions,
									getSuggestionItemProps,
									loading,
								}) => (
									<div className={styles.field}>
										<TextField
											style={{ width: '45vw' }}
											{...getInputProps({
												placeholder: 'Address',
												className:
													'location-search-input',
											})}
										/>

										<div className='autocomplete-dropdown-container'>
											{loading && <div>Loading...</div>}
											{suggestions.map((suggestion) => {
												const className =
													suggestion.active
														? 'suggestion-item--active'
														: 'suggestion-item';
												// inline style for demonstration purpose
												const style = suggestion.active
													? {
															backgroundColor:
																'#fafafa',
															cursor: 'pointer',
													  }
													: {
															backgroundColor:
																'#ffffff',
															cursor: 'pointer',
													  };
												return (
													<div
														{...getSuggestionItemProps(
															suggestion,
															{
																className,
																style,
															}
														)}
													>
														<span>
															{
																suggestion.description
															}
														</span>
													</div>
												);
											})}
										</div>
									</div>
								)}
							</PlacesAutocomplete>

							{showSecondPurchaser === false ? (
								<div
									className='show_purchaser'
									onClick={() => setShowSecondPurchaser(true)}
								>
									<p>+ Add second purchaser</p>
								</div>
							) : (
								<div
									className='remove_purchaser'
									onClick={() =>
										handleRemoveSecondPurchaser()
									}
								>
									<p>x Remove second purchaser</p>
								</div>
							)}

							{showSecondPurchaser === true && (
								<>
									<h2 className='second-purchaser-title'>
										Enter second purchaser's details
									</h2>
									<TextField
										type='text'
										label='First Name'
										name='secondFirstName'
										value={secondFirstName}
										className={styles.field}
										onChange={(e) =>
											onChangeSecondPurchaser(e)
										}
									/>
									<TextField
										type='text'
										label='Last Name'
										name='secondLastName'
										value={secondLastName}
										onChange={(e) =>
											onChangeSecondPurchaser(e)
										}
										className={styles.field}
									/>

									<TextField
										type='email'
										label='Email'
										name='secondEmail'
										value={secondEmail}
										onChange={(e) =>
											onChangeSecondPurchaser(e)
										}
										className={styles.field}
									/>

									<TextField
										type='tel'
										label='Phone Number'
										className={styles.field}
										pattern='[0-9]{3}[0-9]{3}[0-9]{4}'
										name='secondPhoneNumber'
										value={secondPhoneNumber}
										onChange={(e) =>
											onChangeSecondPurchaser(e)
										}
									/>

									<TextField
										type='text'
										label='Date of Birth'
										name='individualDob'
										value={dayjs(
											new Date(
												individualSecondPurchaserDob
											)
										).format('DD MMMM YYYY')}
										className={styles.field}
										onChange={(e) => onChange(e)}
										onClick={() =>
											setShowSecondCalendar(true)
										}
									/>

									{showSecondCalendar === true && (
										<div className='dates_wrapper'>
											<Calendar
												onChange={(e) => {
													setIndividualSecondPurchaserDob(
														new Date(e).getTime()
													);
													setShowSecondCalendar(
														false
													);
												}}
												value={
													new Date(
														individualSecondPurchaserDob
													)
												}
												className='new-react-calendar'
												maxDate={
													new Date(
														new Date().setFullYear(
															new Date().getFullYear() -
																18
														)
													)
												}
												showFixedNumberOfWeeks={true}
											/>
										</div>
									)}

									<TextField
										type='text'
										label='Occupation'
										name='secondOccupation'
										value={secondOccupation}
										className={styles.field}
										onChange={(e) =>
											onChangeSecondPurchaser(e)
										}
									/>

									<FormControl className={styles.field}>
										<InputLabel id='second-id-type-select-label'>
											ID Type
										</InputLabel>
										<Select
											labelId='second-id-type-select-label'
											id='second-id-type-select'
											value={secondIdType}
											name='secondIdType'
											onChange={(e) =>
												onChangeSecondPurchaser(e)
											}
										>
											<MenuItem value='Driver License'>
												Driver License
											</MenuItem>
											<MenuItem value='Passport'>
												Passport
											</MenuItem>
											<MenuItem value='Permanent Residence Card'>
												Permanent Residence Card
											</MenuItem>
											<MenuItem value='other'>
												other
											</MenuItem>
										</Select>
									</FormControl>

									<TextField
										type='text'
										label='ID Number'
										name='secondDlNumber'
										value={secondDlNumber}
										className={styles.field}
										onChange={(e) =>
											onChangeSecondPurchaser(e)
										}
									/>

									<PlacesAutocomplete
										value={addressSecondPurchaser}
										onChange={setAddressSecondPurchaser}
										onSelect={handleSelectSecondPurchaser}
										className={styles.field}
									>
										{({
											getInputProps,
											suggestions,
											getSuggestionItemProps,
											loading,
										}) => (
											<div className={styles.field}>
												<TextField
													style={{ width: '45vw' }}
													{...getInputProps({
														placeholder: 'Address',
														className:
															'location-search-input',
													})}
												/>

												<div className='autocomplete-dropdown-container'>
													{loading && (
														<div>Loading...</div>
													)}
													{suggestions.map(
														(suggestion) => {
															const className =
																suggestion.active
																	? 'suggestion-item--active'
																	: 'suggestion-item';
															// inline style for demonstration purpose
															const style =
																suggestion.active
																	? {
																			backgroundColor:
																				'#fafafa',
																			cursor: 'pointer',
																	  }
																	: {
																			backgroundColor:
																				'#ffffff',
																			cursor: 'pointer',
																	  };
															return (
																<div
																	{...getSuggestionItemProps(
																		suggestion,
																		{
																			className,
																			style,
																		}
																	)}
																>
																	<span>
																		{
																			suggestion.description
																		}
																	</span>
																</div>
															);
														}
													)}
												</div>
											</div>
										)}
									</PlacesAutocomplete>
								</>
							)}

							<button
								className='individualBtn btn btn-primary d-block mr-0 ml-auto'
								onClick={() => handleSave()}
							>
								Save
							</button>
						</div>
					</div>
				) : (
					<div className='corporation_form'>
						<div className={styles.form}>
							<TextField
								type='text'
								label='Name of Corporation'
								name='corporationName'
								value={corporationName}
								onChange={(e) => onChangeBusiness(e)}
								className={styles.field}
							/>
							<TextField
								type='text'
								label='Type of Business'
								name='businessType'
								value={businessType}
								className={styles.field}
								onChange={(e) => onChangeBusiness(e)}
							/>
							<PlacesAutocomplete
								value={businessAddress}
								onChange={setBusinessAddress}
								onSelect={handleSelectBusiness}
								className={styles.field}
							>
								{({
									getInputProps,
									suggestions,
									getSuggestionItemProps,
									loading,
								}) => (
									<div className={styles.field}>
										<TextField
											style={{ width: '45vw' }}
											{...getInputProps({
												placeholder: 'Business Address',
												className:
													'location-search-input',
											})}
										/>

										<div className='autocomplete-dropdown-container'>
											{loading && <div>Loading...</div>}
											{suggestions.map((suggestion) => {
												const className =
													suggestion.active
														? 'suggestion-item--active'
														: 'suggestion-item';
												// inline style for demonstration purpose
												const style = suggestion.active
													? {
															backgroundColor:
																'#fafafa',
															cursor: 'pointer',
													  }
													: {
															backgroundColor:
																'#ffffff',
															cursor: 'pointer',
													  };
												return (
													<div
														{...getSuggestionItemProps(
															suggestion,
															{
																className,
																style,
															}
														)}
													>
														<span>
															{
																suggestion.description
															}
														</span>
													</div>
												);
											})}
										</div>
									</div>
								)}
							</PlacesAutocomplete>
							<TextField
								type='number'
								label='Registration Number'
								name='registrationNumber'
								value={registrationNumber}
								className={styles.field}
								onChange={(e) => onChangeBusiness(e)}
							/>
							<TextField
								type='text'
								label='Director First Name'
								name='directorFName'
								value={directorFName}
								onChange={(e) => onChangeBusiness(e)}
								className={styles.field}
							/>
							<TextField
								type='text'
								label='Director Last Name'
								name='directorLName'
								value={directorLName}
								onChange={(e) => onChangeBusiness(e)}
								className={styles.field}
							/>
							<TextField
								type='tel'
								label='Phone Number'
								className={styles.field}
								pattern='[0-9]{3}[0-9]{3}[0-9]{4}'
								name='businessPhone'
								value={businessPhone}
								onChange={(e) => onChangeBusiness(e)}
							/>

							{/* <TextField
								id='date'
								label='Date of Birth'
								type='date'
								name='dob'
								value={dob}
								onChange={(e) => onChangeBusiness(e)}
								className={styles.field}
								InputLabelProps={{
									shrink: true,
								}}
							/> */}
							{/* <label className={clsx(styles.field, styles.label)}>
								Date of birth
							</label> */}
							{/* <DatePicker
								selected={businessDob}
								id='date'
								placeholderText='Date of Birth'
								maxDate={Date.now()}
								onChange={(date) => setBusinessDob(date)}
								className={clsx(styles.field, styles.datePicker)}
								showTimeSelect={false}
							/> */}

							<button
								className='corporationBtn btn btn-primary d-block mr-0 ml-auto'
								onClick={() => handleSave()}
							>
								Save
							</button>
						</div>
					</div>
				)}
			</div>
		</div>
	);
}

export default Client;
